import { ITableColumn, TableColumnTypeEnum, WidthType } from "./tableColumn.interface";

export const ragCleanupTableColumns: ITableColumn[] = [
    {
        labelPath: "issuesPage.actionDialogLabels.fileName",
        propertyKey: "fileName",
        colType: TableColumnTypeEnum.TextWithIcon,
        width: 40,
        widthType: WidthType.Percentage,
        iconSrc: "fileIcon",
        isSortable: false,
    },
    {
        labelPath: "issuesPage.actionDialogLabels.fileSize",
        propertyKey: "fileSize",
        colType: TableColumnTypeEnum.Text,
        width: 150,
        widthType: WidthType.Percentage,
        isSortable: false,
    },
    {
        labelPath: "issuesPage.actionDialogLabels.uploadDate",
        propertyKey: "uploadDate",
        colType: TableColumnTypeEnum.Text,
        width: 14,
        widthType: WidthType.Percentage,
        isSortable: false,
    },
    {
        labelPath: "issuesPage.actionDialogLabels.scanResults",
        propertyKey: "scanResults",
        colType: TableColumnTypeEnum.TextWithIcon,
        width: 150,
        widthType: WidthType.Percentage,
        isSortable: false,
        textColor: "scanResultTextColor",
        iconSrc: "scanResultIcon",
    },
];
